const { createSlice } = require('@reduxjs/toolkit');

const currencySlice = createSlice({
    name: "currency",
    initialState: {
        currencySymbol: "R$",
        currencyName: "BRL",
        currencyRate: 1
    },
    reducers: {
       setCurrency(state, action) {
  const currencyName = action.payload;

  if (currencyName === "BRL") {
    state.currencySymbol = "R$";
    state.currencyRate = 1;
    state.currencyName = "BRL";
  }
}
    },
});

export const { setCurrency } = currencySlice.actions;
export default currencySlice.reducer;
